import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { TextField, Button, CircularProgress, Snackbar, Alert } from '@mui/material';
import { styled } from '@mui/system';
import { doc, onSnapshot, updateDoc } from 'firebase/firestore';
import { db } from './firebaseConfig';
import './game.css';

const GuestPageContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  padding: '1.25rem',
  boxSizing: 'border-box',
  background: 'transparent',
});

const GuestPageTitle = styled('h1')({
  margin: '0 0 0.5rem',
  fontSize: 'clamp(2rem, 9vw, 4.2rem)',
  lineHeight: 1,
  textAlign: 'center',
});

const GuestPageForm = styled('form')({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  width: '100%',
  maxWidth: '460px',
  padding: '24px',
  border: '2px solid rgba(16, 20, 24, 0.1)',
  borderRadius: 8,
  background: 'rgba(255,255,255,0.84)',
  boxShadow: '0 18px 50px rgba(27, 43, 61, 0.12)',
});

const GuestPageButton = styled(Button)({
  width: '200px',
  alignSelf: 'center',
});

const GuestPage = () => {
  const navigate = useNavigate();
  const [isTriviaOn, setIsTriviaOn] = useState(false);
  const { documentId } = useParams();
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState('');
  const [nameSetInDb, setNameSetInDb] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [error, setError] = useState(null);
  // const [currentQuestion, setCurrentQuestion] = useState("");

  // useEffect(() => {
  //   const currentQuestionCollection = collection(db, 'currentQuestion');
  //   const currentQuestionQuery = query(currentQuestionCollection);
  //   const unsubscribe = onSnapshot(currentQuestionQuery, (snapshot) => {
  //     const updatedCurrentQuestion = snapshot.docs.map((doc) => ({
  //       id: doc.id,
  //       ...doc.data()
  //     }));
  //     setCurrentQuestion(updatedCurrentQuestion[0].id)
  //   });
  //   return () => unsubscribe();
  // }, [currentQuestion]);

  useEffect(() => {
    const unsub = onSnapshot(doc(db, "isTriviaOn", "s5y7fVw6BM5iOZs75VdM"), (doc) => {
      const data = doc.data();
      setIsTriviaOn(Boolean(data?.isOn))
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    const fetchGuestData = async () => {
      try {
        const unsubscribe = onSnapshot(doc(db, "guest", documentId), (doc) => {
          const guestData = doc.data() || {};
          setName(guestData.name || '');
          if (guestData.name) {
            setNameSetInDb(true);
          }
          else {
            setNameSetInDb(false);

          }
          setLoading(false);
        });

        return unsubscribe;
        
      } catch (error) {
        console.error('Error fetching guest data:', error);
        setError('Failed to fetch guest data');
      }
    };

    let unsubscribe;
    fetchGuestData().then((cleanup) => {
      unsubscribe = cleanup;
    });
    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [documentId]);

  const handleSnackbarClose = () => {
    setShowSnackbar(false);
  };

  const handleSave = async (event) => {
    event.preventDefault(); // Prevents the default form submission behavior

    try {
      if (!name.trim()) {
        setError('Please enter your name before joining.');
        return;
      }
      setLoading(true);
      const updatedGuest = {
        name: name.trim(),
      };

      const guestDocRef = doc(db, 'guest', documentId);
      await updateDoc(guestDocRef, updatedGuest);

      setShowSnackbar(true);
      navigate(`/guest-questions/${documentId}`)
    } catch (error) {
      console.error('Error saving guest:', error);
      setError('Failed to save guest');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="game-shell"><GuestPageContainer><CircularProgress /></GuestPageContainer></div>;
  }

  if (error) {
    return <div className="game-shell"><GuestPageContainer><GuestPageForm><Alert severity="error">{error}</Alert><GuestPageButton variant="contained" onClick={() => setError(null)}>Try Again</GuestPageButton></GuestPageForm></GuestPageContainer></div>;
  }

  return (
    <div className="game-shell">
    <GuestPageContainer>
      <p className="game-kicker">Caltrans History Trivia Ride</p>
      <GuestPageTitle>Are we there yet?</GuestPageTitle>
        
      <GuestPageForm onSubmit={handleSave}>
        <TextField
          label="Guest Name"
          variant="outlined"
          value={name}
          onChange={(e) => setName(e.target.value)}
          inputProps={{ maxLength: 48 }}
        />
        <GuestPageButton variant="contained" type="submit">
          Save
        </GuestPageButton>
        {
        isTriviaOn && nameSetInDb && <>
          <GuestPageButton variant="contained" onClick={() => { navigate(`/guest-questions/${documentId}`) }}>
            Go To Trivia
          </GuestPageButton>
          <br />
        </>
      }    
        {
        !isTriviaOn && nameSetInDb && <>
          Please wait for trivia to begin.
          <br />
        </>
      }    
      </GuestPageForm>
      <Snackbar
        open={showSnackbar}
        autoHideDuration={10000}
        onClose={handleSnackbarClose}
        message="Save successful!"
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert  onClose={handleSnackbarClose} severity="success" sx={{ width: '100%' }}>
          Save successful!
        </Alert>
      </Snackbar>
    </GuestPageContainer>
    </div>
  );
};

export default GuestPage;
